import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest,firstValueFrom } from 'rxjs';
import { skip } from 'rxjs/operators';
import { LedgerImportDocumentTypes,LedgerImportEntity } from '../../../dave-data-module/entities/ledger-import.entity';
import { PartnerTypeEnum } from '../../../dave-data-module/entities/partner.entity';
import { DaveMutationChangeAccountsReceivableLedgerArgs } from '../../../dave-data-module/graphql-types';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { State } from '../../../dave-data-module/State';
import { LedgerImportActionTypes } from '../../../dave-data-module/State/actions/accounting.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { getCommissionById } from '../../../dave-data-module/State/selectors/commission.selector';
import { getLedgerImports } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { getPartner } from '../../../dave-data-module/State/selectors/partners.selectors';
import {
NewReportDialogComponent,NewReportDialogComponentDialogData,ReportDialogReturnData
} from '../../../dave-reports/components/new-report-dialog/new-report-dialog.component';
import { SelectArlDialogService } from '../../../dave-reports/components/select-arl-dialog/select-arl-dialog.service';
import { AllReportsMeta,ReportsPageMeta } from '../../../helper/page-metadata';
import * as tsb from '../../../helper/tsb.helper';
import { LoadingService } from '../../../services/loading.service';

@Injectable({
    providedIn: 'root',
})
export class CreateArlFromCommissionService {
    constructor(
        private dialog: MatDialog,
        private store: Store<State>,
        private arlDataService: ArlDataService,
        public LS: LoadingService,
        private router: Router,
        private actions$: Actions,
        private selectArlDialogService: SelectArlDialogService,
    ) {}

    public NewReport(onlyMaterial: boolean, booked: boolean, commissionId: number, includeMaterial: boolean, customerId?: number) {
        this.dialog
            .open<NewReportDialogComponent, NewReportDialogComponentDialogData, ReportDialogReturnData>(NewReportDialogComponent, {
                ...NewReportDialogComponent.DefaultConfig,
                data: {
                    OpenedFromCommission: true,
                    DefaultValues: {
                        documentType: LedgerImportDocumentTypes.Measurement,
                        customerId: customerId ?? undefined
                    },
                },
            })
            .afterClosed()
            .subscribe(async (selectedTemplate) => {
                if (selectedTemplate === 'submit' || selectedTemplate === '') {
                    console.error('not implemented');
                } else if (Object.values(LedgerImportDocumentTypes).some((l) => l === selectedTemplate)) {
                    this.LS.startLoading('create-arls-from-commission');
                    const result = await this.arlDataService.createArlsFromCommission({
                        commissionId: commissionId,
                        includeConstructionDiarys: !onlyMaterial,
                        includeMaterials: includeMaterial,
                        includeResources: !onlyMaterial,
                        includeWorkedTimes: !onlyMaterial,
                        quantitiesFromMaterialList: booked,
                    });
                    this.LS.endLoading('create-arls-from-commission');
                    const dialogRef = await this.selectArlDialogService
                        .open({
                            AllowPriceManipulation: true,
                            AllowQuantityManipulation: true,
                            AllowQuantityTypeManipulation: true,
                            AllowBezeichnungManipulation: true,
                            Arls: result,
                            showForceItemNumbers: false,
                            forceItemNumbersDefaultOn: false,
                        })
                    dialogRef.afterClosed().subscribe(async (arlIds) => {
                        if (arlIds?.ArlOutput.length > 0) {
                            const toChange: DaveMutationChangeAccountsReceivableLedgerArgs[] = [];
                            for (const arl of arlIds.ArlOutput) {
                                toChange.push({
                                    id: arl.Id,
                                    baseCost: arl.BaseCost,
                                    lohnBaseCostPart: arl.SalaryBaseCost,
                                    information: arl.Bezeichnung,
                                    quantity: arl.Quantity,
                                    quantityFormula: arl.QuantityFormula,
                                    quantityTypeId: arl.QuantityTypeId,
                                    multiplikator: 1,
                                    baseCostAllowances: [],
                                });
                            }
                            await this.arlDataService.changeArls(toChange, 100);
                            // Code from new-report-dialog The initial task of the ticket was only to implement invoices. Later, final-,partital invoices should also to be implemented these have a custom logic in new-report-dialog
                            this.LS.startLoading('app-new-report-dialog_CreateDocumentFromType');
                            this.store.dispatch(
                                LedgerImportActionTypes.AddLedgerImportWithDefaults({
                                    Payload: {
                                        accountsReceivableLedgerIds: arlIds.ArlOutput.map((arl) => arl.Id),
                                        documentType: selectedTemplate as LedgerImportDocumentTypes,
                                        commissionId: commissionId,
                                        customerId: customerId ?? null,
                                    },
                                    ARLsForCalculateAmountFromArlIds: arlIds.dictionaryWithRequiredArlsForAmountCalculation,
                                }),
                            );
                            firstValueFrom(this.store.select(getLedgerImports).pipe(skip(1))).then((li) => {
                                if (li) {
                                    const newGenFileNo = li.reduce((highestId, entity) => (entity.Id > highestId ? entity.Id : highestId), -1);
                                    // this.router.navigate([InvoiceEditorMeta.Path, newGenFileNo], {
                                    //     relativeTo: route,
                                    // });
                                    this.LS.endLoading('app-new-report-dialog_CreateDocumentFromType');
                                    this.router.navigate(['/rechnungen_und_angebote/alle', newGenFileNo]);
                                }
                            });
                        }
                    });
                } else if (selectedTemplate instanceof LedgerImportEntity || isLedgerImportEntityLike(selectedTemplate)) {
                    this.LS.startLoading('create-arls-from-commission');
                    const result = await this.arlDataService.createArlsFromCommission({
                        commissionId: commissionId,
                        includeConstructionDiarys: !onlyMaterial,
                        includeMaterials: includeMaterial,
                        includeResources: !onlyMaterial,
                        includeWorkedTimes: !onlyMaterial,
                        quantitiesFromMaterialList: booked,
                    });
                    this.LS.endLoading('create-arls-from-commission');

                    const dialogRef = await this.selectArlDialogService
                        .open( {
                                AllowBezeichnungManipulation: true,
                                AllowPriceManipulation: true,
                                AllowQuantityManipulation: true,
                                AllowQuantityTypeManipulation: true,
                                Arls: result,
                                showForceItemNumbers: false,
                                forceItemNumbersDefaultOn: false,
                            }
                        );
                    dialogRef.afterClosed()
                        .subscribe(async (arlIds) => {
                            if (arlIds?.ArlOutput.length > 0) {
                                const toChange: DaveMutationChangeAccountsReceivableLedgerArgs[] = [];
                                for (const arl of arlIds.ArlOutput) {
                                    toChange.push({
                                        id: arl.Id,
                                        baseCost: arl.BaseCost,
                                        lohnBaseCostPart: arl.SalaryBaseCost,
                                        information: arl.Bezeichnung,
                                        quantity: arl.Quantity,
                                        quantityFormula: arl.QuantityFormula,
                                        quantityTypeId: arl.QuantityTypeId,
                                        multiplikator: 1,
                                        baseCostAllowances: [],
                                    });
                                    await this.arlDataService.changeArls(toChange, 100);
                                }
                                this.LS.startLoading('addLedgerImport');
                                firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess, BaseActionTypes.ErrorAction))).then((val) => {
                                    if (val.type === LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess.type) {
                                        firstValueFrom(this.store.select(getLedgerImports)).then((li) => {
                                            const newGenFileNo = li.reduce((highestId, entity) => (entity.Id > highestId ? entity.Id : highestId), -1);
                                            this.LS.endLoading('addLedgerImport');
                                            this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, newGenFileNo]);
                                        });
                                    } else {
                                        this.LS.endLoading('addLedgerImport');
                                    }
                                });

                                firstValueFrom(combineLatest([this.store.select(getPartner), this.store.select(getCommissionById({ id: commissionId }))])).then(([partner, commission]) => {
                                    let title = undefined;
                                    if (partner.PartnerTypeId === PartnerTypeEnum.TSB) {
                                        title = tsb.getLedgerImportTitle(title, commission);
                                    }
                                    this.store.dispatch(
                                        LedgerImportActionTypes.CreateLedgerImportFromLedgerImport({
                                            Payload: {
                                                rootId: selectedTemplate.Id,
                                                customerId: customerId ?? undefined,
                                                commissionId: commissionId,
                                                isTemplate: false,
                                                documentType: selectedTemplate.DocumentType,
                                                title,
                                                arlIds: arlIds.ArlOutput.map((arl) => arl.Id),
                                            },
                                        }),
                                    );
                                });
                            }
                        });
                }
            });

        function isLedgerImportEntityLike(value: unknown): value is LedgerImportEntity {
            return !!value && typeof value === 'object' && 'Id' in value && 'DocumentType' in value && 'IsTemplate' in value;
        }
    }
}
